import { Data, Layout } from "plotly.js";

import { VALUE_TYPE } from "Components/NumberValue";
import { getPriceFormatFromValue } from "Formatting/index";
import { DEFAULT_CHART_FONT } from "../chartConfig";
import { ChartSize } from "../chartInterface";
import { DonutChartData } from "./donutChartInterface";

export const getDonutData = (data: DonutChartData): Data[] => {
  return [
    {
      values: data.values,
      labels: data.labels,
      hovertext: data.values.map((value) =>
        getPriceFormatFromValue(value, VALUE_TYPE.NOK),
      ),
      marker: { colors: data.colors },
      hole: 0.7,
      type: "pie",
      textposition: "outside",
      textinfo: "text",
      hoverinfo: "label+text",
      sort: false,
    },
  ];
};

export const getDonutLayout = (
  title: string,
  centerSum: string,
  size: ChartSize,
): Partial<Layout> => {
  return {
    font: {
      family: DEFAULT_CHART_FONT,
    },
    title: {
      font: {
        size: 16,
      },
      text: `<b>${title}</b>`,
    },
    //text inside donut
    annotations: [
      {
        font: {
          size: 16,
        },
        showarrow: false,
        text: `<b>${centerSum}</b>`,
      },
    ],
    height: size.height,
    width: size.width,
    showlegend: true,
    legend: {
      font: {
        size: 14,
      },
      orientation: "h",
    },
    dragmode: false,
  };
};
